import { render, staticRenderFns } from "./ItemTypeAdditionalItemList.vue?vue&type=template&id=0ffbb676"
import script from "./ItemTypeAdditionalItemList.vue?vue&type=script&lang=js"
export * from "./ItemTypeAdditionalItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports